import { render, staticRenderFns } from "./FormularioCorreo.vue?vue&type=template&id=5e20ae1c"
import script from "./FormularioCorreo.vue?vue&type=script&lang=js"
export * from "./FormularioCorreo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports